import PropTypes from 'prop-types'
import Link from 'components/Link'

import { StyledButtonHalf, StyledHalfContainer, StyledContainerItem } from './styles'

// default values for styles
const NBRPERCOL = '2'
const BORDERWIDTH = '3'
const BORDERRADIUS = '50'

// item style is saved in list/children/id/style... :sad:
const HalfButtons = ({ appId, items, listStyle, listItems }) => {

  const getItemStyle = (item) => {
    const itemInList = Object.values(listItems).find((i) => i.id === item.id)
    const styleObject = itemInList.style || {}
    return {
      col: styleObject.nbrPerCol || listStyle.nbrPerCol || NBRPERCOL,
      width: styleObject.borderWidth || listStyle.borderWidth || BORDERWIDTH,
      radius: styleObject.borderRadius || listStyle.borderRadius || BORDERRADIUS,
    }
  }

  return (
    <StyledHalfContainer>
      {items.map((item, i) => (
        <StyledContainerItem $columns={getItemStyle(item).col} key={i}>
          <StyledButtonHalf
            as={Link}
            $borderWidth={getItemStyle(item).width}
            $borderRadius={getItemStyle(item).radius}
            id={`\'${item.name}\` button`}
            dataGa="link button-round image"
            href={`/${appId}/card/${item.cardId}`}
            $img={item.icon || item.img || undefined}
          >
            <span style={{ display: 'none' }}>{item.shortName}</span>
          </StyledButtonHalf>

          {item.shortName && (
            <Link
              id={`\'${item.name}\` link`}
              dataGa="link button-round image"
              href={`/${appId}/card/${item.cardId}`}
            >
              <span>{item.shortName}</span>
            </Link>
          )}
        </StyledContainerItem>
      ))}
    </StyledHalfContainer>
  )
}

HalfButtons.propTypes = {
  appId: PropTypes.string,
  items: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
  listStyle: PropTypes.object,
  listItems: PropTypes.any,
}

export default HalfButtons
